module.exports = __webpack_public_path__ + "img/refresh.b1b03f76.svg";